/**
 * Copyright (c) 2020-2021 Perficient, Inc.
 * Unauthorized copying or distribution of this file prohibited without the express permission of Perficient.
 */

import { v2, errorToObject } from "@prftesp/cle-logger";
import { actions as contactPathActions } from "./reducer";
import errorCodes from "../../../../utility/errorCodes";
import { getCallHistory } from "../../services/CallHistory";
import { getSentimentAnalysisResults } from "../../services/RealtimeSentimentAnalysisService";

const COMPONENT_NAME = "CCP components/contactData";

export const removeContactDataFromState = (dispatch, { contactId }) => {
	dispatch({ key: contactPathActions.REMOVE_CONTACT_DATA, contactId });
};

export const getHistoryAction = async (dispatch, { contact }) => {
	try {
		dispatch({ type: contactPathActions.LOADING_CONTACT_HISTORY, contactId: contact.contactId });
		const data = await getCallHistory(contact.contactId);
		dispatch({ type: contactPathActions.SUCCESS_CONTACT_HISTORY, history: data, contactId: contact.contactId });
	} catch (error) {
		v2.error("Error getting contact history", {
			additionalData: { error: errorToObject(error) },
			componentName: COMPONENT_NAME,
			logCode: errorCodes.CONTACT_HISTORY_GET_ERROR,
		});
		dispatch({
			type: contactPathActions.FAILED_CONTACT_HISTORY,
			error: "Could not retrieve contact history.",
			contactId: contact.contactId,
		});
	}
};

export const setSMSMessageFormForContact = (dispatch, contactId, smsMessageForm) => {
	dispatch({ type: contactPathActions.SET_CONTACT_SMS_MESSAGE_FORM, contactId, smsMessageForm });
};

export const getContactSentimentAnalysisResults = async (dispatch, { contact }) => {
	try {
		dispatch({ type: contactPathActions.LOADING_SENTIMENT_RESULTS, contactId: contact.contactId });
		const data = await getSentimentAnalysisResults(contact.contactId);
		if (!data.errorMessage) {
			dispatch({
				type: contactPathActions.SUCCESS_SENTIMENT_RESULTS,
				sentimentResults: data,
				contactId: contact.contactId,
			});
		} else {
			dispatch({
				type: contactPathActions.FAILED_SENTIMENT_RESULTS,
				error: data.errorMessage,
				contactId: contact.contactId,
			});
		}
	} catch (error) {
		v2.error("Error getting contact sentiment analysis", {
			additionalData: { error: errorToObject(error) },
			componentName: COMPONENT_NAME,
			logCode: errorCodes.CONTACT_SENTIMENT_ANALYSIS_RESULTS_GET_ERROR,
		});
		dispatch({
			type: contactPathActions.FAILED_SENTIMENT_RESULTS,
			error: "Something went wrong and we could not retrieve sentiment results. Please try again.",
			contactId: contact.contactId,
		});
	}
};
